import { render, staticRenderFns } from "./CustomerCreateForm.vue?vue&type=template&id=8e47107e"
import script from "./CustomerCreateForm.vue?vue&type=script&lang=js"
export * from "./CustomerCreateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports